import React from 'react';
import { Create, Edit } from 'react-admin';
import SubcategorySummary from './SubcategorySummary';
import { withStyles } from '@material-ui/core/styles';
import { FormSpy } from 'react-final-form';
import SimpleFormWithSave from '../../core/components/form/SimpleFormWithSave';

const styles = () => ({
  fullWidth: {
    width: '100%'
  }
});

const SubcategoryForm = props => {
  const {
    handleSubmit,
    setSubcategoryFormProps,
    operation,
    fetchEnd,
    fetchStart,
    showNotification,
    handleDialogToggle,
    showDialog,
    okButtonLabel,
    popupTitle,
    crudGetList,
    setSort,
    loaded,
    currentSort,
    classes,
    categoryId,
    ...operationProps
  } = props;

  if (operation === 'Create') {
    return (
      <Create
        {...operationProps}
        record={{
          categoryId,
          order: 0,
          triggerEmail: false,
          description: '',
          templateId: 0,
          categoryTypeId: 0,
          filterType: 'UNKNOWN1',
          excludeFromDailySummary: false
        }}
        className={classes.fullWidth}
      >
        <SimpleFormWithSave
          toolbar={null}
          resource="subcategories"
          onSave={handleSubmit}
          variant="standard"
          margin="normal"
        >
          <FormSpy>
            {props => {
              setSubcategoryFormProps(props);
              return <SubcategorySummary />;
            }}
          </FormSpy>
        </SimpleFormWithSave>
      </Create>
    );
  } else {
    return (
      <Edit {...operationProps} className={classes.fullWidth}>
        <SimpleFormWithSave
          toolbar={null}
          resource="subcategories"
          onSave={handleSubmit}
          variant="standard"
          margin="normal"
        >
          <FormSpy>
            {props => {
              setSubcategoryFormProps(props);
              return <SubcategorySummary />;
            }}
          </FormSpy>
        </SimpleFormWithSave>
      </Edit>
    );
  }
};

export default withStyles(styles)(SubcategoryForm);
